import type {
  EntitiesCheckMfaResponse,
  EntitiesCreateSessionRequest,
  EntitiesCreateSessionResponse
} from './axilon-v2-api.generated'

import { generatedApi } from './axilon-v2-api.generated'
import applyExtraOptionsOverrides from './overrides/extra-options'
import applySideEffectOverrides from './overrides/side-effects'
import applyTagOverrides from './overrides/tags'

type LoginWithMFACheckResponse = EntitiesCreateSessionResponse | EntitiesCheckMfaResponse

const enhancedApi = applySideEffectOverrides(
  applyTagOverrides(applyExtraOptionsOverrides(generatedApi))
)

const api = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    loginWithMFACheck: build.mutation<LoginWithMFACheckResponse, EntitiesCreateSessionRequest>({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      async queryFn(arg, { dispatch }): Promise<any> {
        const { username, password, otp, organizationSlug } = arg

        if (!otp) {
          const result = await dispatch(
            api.endpoints.checkMfa.initiate({ username, password, organizationSlug })
          )

          if (result.data?.mfaEnabled || result.error) {
            return result
          }
        }

        return dispatch(api.endpoints.login.initiate(arg))
      },
      extraOptions: { public: true }
    })
  })
})

export const { useLoginWithMFACheckMutation } = api

export * from './axilon-v2-api.generated'

export { api }
export default api
